<app-website-header></app-website-header>
<div class="header mainImage">
    <img src="../../../../../assets/images/webinars-website.jpg" width="100%" height="auto" />
    <div class="header-name">
        <p style="font-family: 'Libre Baskerville' !important;">Webinars</p>
    </div>
</div>
<div>
    <div class="mx-3 mt-4 breadcrummd-div" style="margin-bottom: 29px;">
        <img class="breadcrumb-icon" src="../../../assets/images/icons/home-icon.svg" alt="" [routerLink]="['/']"style="cursor:pointer">
        <a class="breadcrummb ps-2" style="color:#0D87C8 ;" [routerLink]="['/']">Home</a>
        <a class="breadcrummb" style="color:#0D87C8 ;">/</a>
       <a class="breadcrummb" style="color:#0D87C8 ;"  (click)="navigate()">Webinar</a>
        <a class="breadcrummb" style="color:#0D87C8 ;">/</a>
        <a class="breadcrummb" style="color:#0D87C8 ;" *ngIf="webinar && !webinar.webinarTitle">{{selectedTabName}} </a>
        <a class="breadcrummb" style="color:#0D87C8 ;" *ngIf="webinar && webinar.webinarTitle">{{webinar.webinarTitle | titlecase}}  {{selectedTabName}}</a> 
      
    </div>
    <div class="p-5 mainContainer" style="background-color: #F5F5F5; ">
        <div class="containerr p-5 mt-5" style="background-color: #ffffff; border-radius: 10px;">
            <div class="header-container d-flex flex-column flex-lg-row  gap-3" >
                <div class="header d-flex webinarImage" style="width: 80%;">
                    <img [src]="webinar?.image" alt="" class ="webinarImage webinarImageTag" style="width: 100%; max-height: 400px; min-height: 300px;">
                    <div class="time">
                        <div class="days">
                        <span class="number"> {{timeToWebinar.length>0?timeToWebinar[0]:'00'}} </span>
                        <hr>
                            <span class="string">DAYS</span>
                        </div>
                        <div class="hrs">
                            <span class="number"> {{timeToWebinar.length>0?timeToWebinar[1]:'00'}} </span> 
                            <hr>
                            <span class="string">HRS</span>
                        </div>
            
                        <div class="mins">
                            <span class="number"> {{timeToWebinar.length>0?timeToWebinar[2]:'00'}} </span>
                            <hr>
                            <span class="string">MINS</span>
                        </div>   
            
                        <div class="secs">
                            <span class="number"> {{timeToWebinar.length>0?timeToWebinar[3]:'00'}} </span>
                            <hr>
                            <span class="string">SECS</span>
                        </div>
                    </div>
                </div>

                <div class="header-info d-flex flex-column gap-1 " style="width: 40%">
                <div class="sponsor">
                <div >
                    <ng-container *ngIf="webinar?.sponsored === true">
                        <div class="sponsored posted-section">
                            <span class="sponsored-name">Sponsored by</span>
                            <img src="../../../../../assets/images/logomedworld32full.svg">
                        </div>
                    </ng-container>
                    <ng-container *ngIf="webinar?.sponsored === false">
                        <div *ngIf="adminCreated" class="sponsored posted-section">
                            <span class="sponsored-name">Posted by</span>
                            <img src="../../../../../assets/images/logomedworld32full.svg">
                        </div>
                        <div *ngIf="!adminCreated" class="sponsored posted-section">
                            <span class="sponsored-name">Sponsored by</span>
                            <img [src]="webinar?.logo">
                        </div>
                    </ng-container>
                </div>
                <div class="sponsored sponsor-host d-flex flex-column">
                        <span class="sponsored-name">Hosted by</span>
                        <div class="card-info-person d-flex card-info-person-container ">
                            <img class="logo" [src]="webinar?.hostImage" width="52px" height="52px" style="border-radius: 100%;" />
                            <div class="d-flex flex-column justify-content-around sponsor-profile-container">
                                <p class="person-name" *ngFor="let doc of webinar?.speakersName" > {{doc}}</p>
                                <p class="specialization m-0"> {{ webinar?.speciality }} </p>
                                <span class="date-font">
                                    {{ webinarDateTime | date:'yyyy-MM-dd, h:mm a' }} {{ timezoneAbbreviation }}
                                  </span>
                            </div>
                        </div>
                    </div>
                </div>
                    <button class="btn btn-primary d-flex flex-row align-items-center justify-content-center py-3 gap-3" (click)="registerToWebinar()" [disabled]="iswebinarActive || isRegistered "><img class="d-flex" src="../../../assets/images/icons/calender-icon.svg"> 
                        <span class="button-txt d-flex flex-row">
                            {{ (!signin)? ((iswebinarActive)? ('Registration closed'):('Sign in for Registration')):
                                (
                                    (iswebinarActive)? ('Registration closed'): (isRegistered) ? 'Registered' : ((webinar?.paid === true) ? 'Pay ₹' + webinar?.amount + ' To Register' : 'Register')
                                ) 
                            }}
                        </span>
                    </button>
                    <button *ngIf = "iswebinarActive && webinar?.webinarRecordUrl"  class="btn recording-button d-flex flex-row align-items-center justify-content-center py-3 gap-3" (click)="onViewRecording()"><img class="d-flex recording-img" src="../../../assets/images/recording_svg.svg">
                        <span class="button-txt d-flex flex-row">
                            View Recording
                        </span>
                    </button>
                </div>
            </div>

            <div class="mt-5 webinar-details">
                <p class="txt-heading"> {{ webinar?.webinarTitle }} </p>
                <p class="infoo" [innerHTML]="webinar?.aboutWebinar" ></p>
            </div>
    </div>
    </div>
<app-website-footer></app-website-footer>